import { t } from "i18next";
import React, { useState } from "react";
import Autosuggest from "react-autosuggest";
import { tracks, getTrackTitle, sanitizeTrackTitle } from "../domain/tracks";

interface TrackInputProps {
  inputRef: React.RefObject<HTMLInputElement>;
  currentGuess: string;
  setCurrentGuess: (guess: string) => void;
}

export function TrackInput({
  inputRef,
  currentGuess,
  setCurrentGuess,
}: TrackInputProps) {
  const [suggestions, setSuggestions] = useState<string[]>([]);

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={({ value }) =>
        setSuggestions(
          tracks
            .map((t) => getTrackTitle(t))
            .filter((trackTitle) =>
              sanitizeTrackTitle(trackTitle).includes(sanitizeTrackTitle(value))
            )
        )
      }
      onSuggestionsClearRequested={() => setSuggestions([])}
      getSuggestionValue={(suggestion) => suggestion}
      renderSuggestion={(suggestion) => (
        <div className="border-2 rounded-md dark:bg-slate-800 dark:text-slate-100">
          {suggestion}
        </div>
      )}
      containerProps={{
        className: "border-2 rounded-md flex-auto relative",
      }}
      inputProps={{
        ref: inputRef,
        className: "w-full rounded-md dark:bg-slate-800 dark:text-slate-100",
        placeholder: t("placeholder"),
        value: currentGuess,
        onChange: (_e, { newValue }) => setCurrentGuess(newValue),
        autoFocus: true,
      }}
      renderSuggestionsContainer={({ containerProps, children }) => (
        <div
          {...containerProps}
          className={`${containerProps.className} absolute rounded-md bottom-full w-full bg-white mb-1 divide-x-2 max-h-52 overflow-auto`}
        >
          {children}
        </div>
      )}
    />
  );
}
